import discord from './discord.svg';
import facebook from './facebook.svg';
import github from './github.svg';
import medium from './medium.svg';
import reddit from './reddit.svg';
import station from './station.svg';
import telegram from './telegram.svg';
import x from './x.svg';

export { discord, facebook, github, medium, reddit, station, telegram, x };
